import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=56aa2045&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56aa2045')) {
      api.createRecord('56aa2045', component.options)
    } else {
      api.reload('56aa2045', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=56aa2045&", function () {
      api.rerender('56aa2045', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iKdNSyPAhn4t/JS/imageCarousel.vue"
export default component.exports